import React from 'react';
import { CAIRNS_LOGO_IMAGE_URL, IMAGE_PREFIX } from 'assets/images/images';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './DevicePaneV2.scss';

export const DevicePaneV2: React.FC = () => {
  return (
    <div className={style.container}>
      <img src={CAIRNS_LOGO_IMAGE_URL} alt="Cairns Health" className={style.logo} />
      <Text variant="h4" weight={500} color={Color.GRAY_BLUE} className={style.title}>
        Use the Cairns Companion app to set up your Luna device
      </Text>
      <div className={style.imageContainer}>
        <img src={`${IMAGE_PREFIX}/IphoneMockup.png`} alt="Cairns Companion app" className={style.imageMockup} />
      </div>
    </div>
  );
};
